var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCurrency(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 4.16667C5.03342 4.16667 4.25 4.68875 4.25 5.33333C4.25 5.97792 5.03342 6.5 6 6.5C6.96658 6.5 7.75 7.02208 7.75 7.66667C7.75 8.31125 6.96658 8.83333 6 8.83333V4.16667ZM6 4.16667C6.6475 4.16667 7.21333 4.40117 7.51608 4.75L6 4.16667ZM6 4.16667V3.58333V4.16667ZM6 4.16667V8.83333V4.16667ZM6 8.83333V9.41667V8.83333ZM6 8.83333C5.3525 8.83333 4.78667 8.59883 4.48392 8.25L6 8.83333ZM11.25 6.5C11.25 7.18944 11.1142 7.87213 10.8504 8.50909C10.5865 9.14605 10.1998 9.7248 9.71231 10.2123C9.2248 10.6998 8.64605 11.0865 8.00909 11.3504C7.37213 11.6142 6.68944 11.75 6 11.75C5.31056 11.75 4.62787 11.6142 3.99091 11.3504C3.35395 11.0865 2.7752 10.6998 2.28769 10.2123C1.80018 9.7248 1.41347 9.14605 1.14963 8.50909C0.885795 7.87213 0.75 7.18944 0.75 6.5C0.75 5.10761 1.30312 3.77226 2.28769 2.78769C3.27226 1.80312 4.60761 1.25 6 1.25C7.39239 1.25 8.72774 1.80312 9.71231 2.78769C10.6969 3.77226 11.25 5.10761 11.25 6.5Z",
    fill: "none",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrency);
export default __webpack_public_path__ + "static/media/Currency.b4a6e630.svg";
export { ForwardRef as ReactComponent };